import React from "react"
import * as styles from "./Styles/Paging.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const Pager = (props) => {
  // seriesはcurrent pageがstringで渡ってくる
  // ["1", 2, 3, "gap", 8]
  const currentPage = props.pagy.page.toString()
  const narrow = props.series && props.series.length > 7

  return (
    <nav className={styles.navigation} role="navigation" aria-label="pager">
      {props.series.length > 1 &&
        props.series.map((page, i) => (
          <React.Fragment key={i}>
            {page !== currentPage && page !== "gap" && (
              <span className={cn("nav", narrow ? "nav--narrow" : "")}>
                <a href={`${location.origin}${location.pathname}?page=${page}`}>
                  {page}
                </a>
              </span>
            )}
            {page !== currentPage && page === "gap" && (
              <span className={cn("nav", narrow ? "nav--narrow" : "")}>…</span>
            )}
            {page === currentPage && (
              <span
                className={cn("nav", "current", narrow ? "nav--narrow" : "")}
              >
                {page}
              </span>
            )}
          </React.Fragment>
        ))}
    </nav>
  )
}

export default Pager
